import { Injectable } from '@angular/core';

@Injectable()
export class Globals {
  notificationcount: number = 0;
  cartcount: number = 0;
  searcharray: any[];
}
